import { render, staticRenderFns } from "./RoutePull.vue?vue&type=template&id=db98b790"
import script from "./RoutePull.vue?vue&type=script&lang=js"
export * from "./RoutePull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports